"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TrackingJs;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useTrackingWriteKey = _interopRequireDefault(require("./utils/useTrackingWriteKey"));

var _consentManagerContainerWrapper = _interopRequireDefault(require("./wrappers/consentManagerContainerWrapper"));

var _helmetWrapper = _interopRequireDefault(require("./wrappers/helmetWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function TrackingJs(props) {
  const writeKey = (0, _useTrackingWriteKey.default)(props.writeKey, props.tenant, props.culture, props.environment);

  if (!writeKey) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }

  return /*#__PURE__*/React.createElement("div", {
    id: "react-tracking-root-wrapper"
  }, /*#__PURE__*/React.createElement(_helmetWrapper.default, _extends({}, props, {
    writeKey: writeKey
  })), /*#__PURE__*/React.createElement(_consentManagerContainerWrapper.default, _extends({}, props, {
    writeKey: writeKey
  })));
}

TrackingJs.propTypes = {
  tenant: _propTypes.default.string.isRequired,
  culture: _propTypes.default.string.isRequired,
  environment: _propTypes.default.string.isRequired,
  integrations: _propTypes.default.object,
  version: _propTypes.default.string,
  suppressReloadOnConsentSubmit: _propTypes.default.bool,
  writeKey: _propTypes.default.string,
  consentData: _propTypes.default.object
};